import { ExternalLink as ExternalLinkIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface ExternalLinkProps {
  /** URL to link to */
  href: string
  /** Link content */
  children: React.ReactNode
  /** Whether to show the external link icon */
  showIcon?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * Link with external arrow icon (↗).
 * Opens in new tab with proper security attributes.
 * 
 * @example
 * ```tsx
 * <ExternalLink href="https://dev.azure.com/org/project/_git/repo">
 *   org/repo
 * </ExternalLink>
 * ```
 */
export function ExternalLink({
  href,
  children,
  showIcon = true,
  className,
}: ExternalLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-1 text-primary hover:underline',
        className
      )}
    >
      {children}
      {showIcon && <ExternalLinkIcon className="h-3 w-3" />}
    </a>
  )
}
